import { useEffect, useState } from "react";

/**
 * A custom hook to dynamically load the Cloudflare Turnstile script.
 *
 * @param {string} verifyURL - The URL of the Turnstile verification script.
 */
const useTurnstileScript = verifyURL => {
  const [scriptLoaded, setScriptLoaded] = useState(false);
  const [scriptError, setScriptError] = useState(false);

  const handleScriptError = () => {
    setScriptError(true);
    setScriptLoaded(false);
  };

  useEffect(() => {
    if (typeof window === "undefined") {
      setScriptLoaded(false);
      return;
    }
    if (window.turnstile && window.turnstile.render) {
      setScriptLoaded(true);
      return;
    }

    const script = document.createElement("script");
    script.src = `${verifyURL}?render=explicit`;
    script.onload = () => {
      setScriptLoaded(true);
    };
    script.onerror = () => {
      handleScriptError();
    };
    script.onabort = () => {
      handleScriptError();
    };
    script.defer = true;
    document.getElementsByTagName("head")[0].appendChild(script);

    return () => {
      setScriptLoaded(false);
      setScriptError(false);
    };
  }, [verifyURL]);

  return { scriptLoaded, scriptError };
};
export default useTurnstileScript;
